import { jsx as _jsx } from "react/jsx-runtime";
import { createContext, useContext, useState, useEffect, useRef } from 'react';
const BreadcrumbContext = createContext(undefined);
export function BreadcrumbProvider({ children }) {
    const [breadcrumbs, setBreadcrumbs] = useState([]);
    return (_jsx(BreadcrumbContext.Provider, { value: { breadcrumbs, setBreadcrumbs }, children: children }));
}
export function useBreadcrumbs() {
    const context = useContext(BreadcrumbContext);
    return context?.breadcrumbs ?? [];
}
export function useBreadcrumbContext() {
    return useContext(BreadcrumbContext);
}
export function useSetBreadcrumbs(breadcrumbs) {
    const context = useContext(BreadcrumbContext);
    const ctxRef = useRef(context);
    ctxRef.current = context;
    // eslint-disable-next-line react-hooks/exhaustive-deps
    const serialized = JSON.stringify(breadcrumbs.map(b => b.label));
    useEffect(() => {
        const ctx = ctxRef.current;
        if (!ctx)
            return;
        ctx.setBreadcrumbs(breadcrumbs);
        return () => ctx.setBreadcrumbs([]);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [serialized]);
}
